__turbopack_context__.v({
  "cards": "FIBf-G_cards",
  "container": "FIBf-G_container",
  "hasPrereqs": "FIBf-G_hasPrereqs",
  "prereqs": "FIBf-G_prereqs",
});
